import { useGetMeQuery } from 'store/services/user/meApi';

export const useUserRoles = (skip: boolean = false) => {
  const { data: user, isSuccess, isError } = useGetMeQuery(undefined, { skip });

  // SECURITY: Using backend RBAC system
  // Backend validates roles on every API call
  // This is for UI display only - actual security is enforced server-side

  const isAdmin = user?.roles?.includes('admin') || false;
  const isWriter = user?.roles?.includes('writer') || false;
  // isPartner: has live lookup API access; reveals the Partner API sidebar link and page
  const isPartner = user?.roles?.includes('partner-api') || false;

  // hasAdminAccess: can see the Admin sidebar link and access admin area
  // True for full admins and writers
  const hasAdminAccess = isAdmin || isWriter;

  // rolesResolved: the /users/me query has settled (returned data or errored), so the
  // role booleans reflect the real answer rather than the undefined initial state.
  // Route guards must wait on this to avoid bouncing a valid user during load.
  const rolesResolved = skip || isSuccess || isError;

  return { isAdmin, isWriter, isPartner, hasAdminAccess, rolesResolved, user };
};
